module.exports = __webpack_public_path__ + "static/media/work-with-us-people.dd7b234a.jpg";